<template>
  <div class="container">
    <div class="row">
      <div class="not-found col-lg-4 col-xl-4">
        <h1>404</h1>
        <h2>找不到此頁面</h2>
      </div>
      
    </div>
    
  </div>
</template>

<script>
  export default {
    name: 'PageNotFound',
  }
</script>

<style lang="scss" scoped>
  .not-found {
    margin: 0 auto;
  }
</style>